import React from 'react';

// Main App component
const App = () => {
  return (
    // The main background color is set to #121212
    <div className="min-h-screen bg-[#121212] font-sans text-gray-100 p-4 sm:p-6 lg:p-8 flex items-center justify-center">
      <div className="max-w-6xl w-full bg-[#1F425E] rounded-3xl shadow-2xl overflow-hidden md:flex">
        {/* Left Section: Content */}
        <div className="p-6 sm:p-10 md:p-12 flex-1 flex flex-col justify-center text-center md:text-left">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-4 leading-tight">
            SplitScan: <br className="hidden sm:inline"/> The Ultimate Bill Splitting Solution
          </h1>
          <p className="text-lg sm:text-xl text-gray-300 mb-0 max-w-xl mx-auto md:mx-0">
            Snap a photo of your restaurant check and our AI-powered receipt scanner instantly divides costs fairly. Say goodbye to calculator math and awkward money conversations.
          </p>
          <br></br>
          <h2>Need help with SplitScan?</h2>
<p>
  <a
    href="mailto:hello@recio.app"
    style={{ color: '#4399bb', fontWeight: 'bold' }}
  >
    Email Support: hello@recio.app
  </a>
</p>

<a
  href="https://apps.apple.com/gb/app/splitscan-instant-bill-split/id6742898870"
  target="_blank"
  rel="noopener noreferrer" // This is required
>
  <img src="/app_store.svg" alt="App Store Icon" className="w-40 h-32 mr-4" />
</a>

        </div>

        {/* Right Section: Device Mockup */}
        {/* Background color for the device mockup section is also #1F425E */}
        <div className="md:w-1/2 flex items-center justify-center p-6 sm:p-8 md:p-12 bg-[#000000] rounded-b-3xl md:rounded-r-3xl md:rounded-bl-none">
          <div className="relative w-64 h-auto aspect-[9/19] bg-black rounded-3xl shadow-2xl overflow-hidden border-8 border-gray-900">
            {/* Device screen */}
            <div className="absolute inset-0 m-1 bg-white rounded-2xl flex items-center justify-center overflow-hidden">
              <img
                src="/device_mockup.png" // Changed to device_mockup.png from public folder
                alt="SplitScan App Screenshot"
                className="w-full h-full object-cover"
                onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/300x600/1F425E/ffffff?text=Image+Load+Error"; }}
              />
            </div>
            {/* Speaker cutout (top) */}
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-16 h-2 bg-black rounded-b-md"></div>
            {/* Home button/fingerprint sensor (bottom, if applicable) */}
            <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 w-10 h-1.5 bg-black rounded-full"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
